import React from 'react';
import "./components.css";
const Footer = () => {
  const year = new Date().getFullYear()
  return (
    <>
      <footer className='site-footer text-center'>
        Project made with 💖 by <a href="https://collinsakinbami.netlify.app" target="_blank">Collins Akinbami</a>
        <br />
        &copy; 2021 - {year}
      </footer>
    </>
  )
}

export default Footer
